export const VALUE_ROW_NAMES = [
  {
    system_key: 'ph_h2o',
    name: 'pH (H2O)', // /v2/soil_diagnosis_items から来る値は 'pH (H₂O)'
  },
  {
    system_key: 'ec',
    name: 'EC',
  },
  {
    system_key: 'annmoniatai_tisso',
    name: 'アンモニア態窒素',
  },
  {
    system_key: 'syosantai_tisso',
    name: '硝酸態窒素',
  },
  {
    system_key: 'mukitai_tisso',
    name: '無機態窒素',
  },
  {
    system_key: 'yuukoutai_rinsan_toruoguhou',
    name: '有効態リン酸[トルオーグ法]',
  },
  {
    system_key: 'yuukoutai_rinsan_burei2',
    name: '有効態リン酸[ブレイNo.2準法]',
  },
  {
    system_key: 'koukansei_kari',
    name: '交換性加里',
  },
  {
    system_key: 'koukansei_sekkai',
    name: '交換性石灰',
  },
  {
    system_key: 'koukansei_kudo',
    name: '交換性苦土',
  },
  {
    system_key: 'yuukoutai_keisan',
    name: '有効態ケイ酸',
  },
  {
    system_key: 'kakyuutai_tisso',
    name: '可給態窒素',
  },
  {
    system_key: 'rinsan_kyuushuu_keisuu',
    name: 'リン酸吸収係数',
  },
  {
    system_key: 'cec',
    name: 'CEC',
  },
  {
    system_key: 'hushoku_percent',
    name: '腐植',
  },
  {
    system_key: 'yuuri_sankatetsu',
    name: '遊離酸化鉄',
  },
  {
    system_key: 'kari_houwado',
    name: '加里飽和度',
  },
  {
    system_key: 'sekkai_houwado',
    name: '石灰飽和度',
  },
  {
    system_key: 'kudo_houwado',
    name: '苦土飽和度',
  },
  {
    system_key: 'enki_houwado',
    name: '塩基飽和度',
  },
  {
    system_key: 'sekkai_kudohi',
    name: '石灰苦土比',
  },
  {
    system_key: 'kudo_karihi',
    name: '苦土加里比',
  },
  {
    system_key: 'suiyosei_houso',
    name: '水溶性ホウ素',
  },
  {
    system_key: 'koukansei_mangan',
    name: '交換性マンガン',
  },
  {
    system_key: 'ikangensei_mangan',
    name: '易還元性マンガン',
  },
  {
    system_key: 'kakyuutai_io',
    name: '可給態硫黄',
  },
];
